/* LN free bag charm auto-add - trial Oct 2026.
   Reads [data-ln-gift-bar] (snippets/free-gift-bar.liquid) and:
   - adds the Mini Organiser once jewellery spend reaches the threshold
   - removes it again (only if WE added it) when the cart drops back under
   - respects a customer removing it: no re-adding this visit unless they tap "Add it". */
(function () {
  if (window.__lnFreeGift) return;
  window.__lnFreeGift = true;

  var STATE_KEY = 'ln_free_gift_state'; // '' | 'added' | 'declined'
  var busy = false;
  var timer = null;

  function getState() { try { return sessionStorage.getItem(STATE_KEY) || ''; } catch (e) { return ''; } }
  function setState(v) { try { if (v) { sessionStorage.setItem(STATE_KEY, v); } else { sessionStorage.removeItem(STATE_KEY); } } catch (e) {} }

  function isCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function refresh() {
    if (isCartPage()) { window.location.reload(); return; }
    if (window.eventBus) { window.eventBus.emit('render:cart:drawer'); }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, [data-header-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  function post(url, body) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  function addGift(variantId) {
    busy = true;
    return post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: { _ln_free_gift: '1' } }] })
      .then(function () { setState('added'); refresh(); })
      .catch(function () { setState('declined'); })
      .finally(function () { busy = false; });
  }

  function removeGift(key) {
    busy = true;
    return post('cart/change.js', { id: key, quantity: 0 })
      .then(function () { refresh(); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function check() {
    if (busy) return;
    var el = document.querySelector('[data-ln-gift-bar]');
    if (!el) return;
    var qualifies = Number(el.dataset.eligible) >= Number(el.dataset.threshold);
    var hasGift = el.dataset.hasGift === 'true';
    var autoKey = el.dataset.autoKey;
    var available = el.dataset.available === 'true';
    var state = getState();

    if (qualifies && !hasGift) {
      if (state === 'added') { setState('declined'); return; } // customer removed it
      if (state === 'declined' || !available) return;
      addGift(el.dataset.variant);
    } else if (!qualifies && autoKey) {
      if (state !== 'declined') setState('');
      removeGift(autoKey);
    } else if (!qualifies && state === 'added') {
      setState('');
    }
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 250); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ln-gift-add]');
    if (!btn) return;
    e.preventDefault();
    var el = document.querySelector('[data-ln-gift-bar]');
    if (!el || busy) return;
    setState('');
    addGift(el.dataset.variant);
  });

  function start() {
    schedule();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-ln-gift-bar]') || n.querySelector('[data-ln-gift-bar]'))) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
